import { SpanContext, trace, context, Span } from '@opentelemetry/api';
import tracer from 'src/tracer';

let spanParentList: SpanContext[] = [];

const addParentSpan = (parent: SpanContext) => spanParentList.push(parent);

const removeParentSpan = (spanId: string) =>
  (spanParentList = spanParentList.filter((spanCtx: SpanContext) => spanCtx.spanId !== spanId));

/**
 * Creates and returns a Span with all of the configured properties
 * @param name name of Span
 * @param parentSpanContext parent Span context to assign to this span
 * @param standAlone don't add this Span to the parent stack
 * @param noParent don't assign a parent to this Span
 */
export const createSpan = (
  name: string,
  parentSpanContext?: SpanContext,
  standAlone: boolean = false,
  noParent: boolean = false,
): Span => {
  if (!parentSpanContext && !noParent) {
    parentSpanContext =
      spanParentList.length > 0 ? spanParentList[spanParentList.length - 1] : undefined;
  }

  const span = parentSpanContext
    ? tracer.startSpan(name, {}, trace.setSpanContext(context.active(), parentSpanContext))
    : tracer.startSpan(name);

  if (!standAlone) {
    addParentSpan(span.spanContext());
  }

  return span;
};

export const endSpan = (span: Span) => {
  removeParentSpan(span.spanContext().spanId);
  span.end();
};
